import type { Gender, Student, StudentFormValues, StudentRow } from '../types/student';

function text(value: string | null | undefined): string {
  return value ?? '';
}

function millis(value: string | null | undefined): number {
  if (!value) return 0;
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

/** Maps a Supabase row onto the shape the UI works with. */
export function fromRow(row: StudentRow): Student {
  const createdAtMs = millis(row.created_at);
  return {
    id: String(row.id),
    ownerId: text(row.owner_id),
    fullNames: text(row.full_names),
    gender: (text(row.gender) as Gender) || '',
    className: text(row.class_name),
    fatherName: text(row.father_name),
    fatherPhone: text(row.father_phone),
    motherName: text(row.mother_name),
    motherPhone: text(row.mother_phone),
    note: text(row.note),
    createdAtMs,
    updatedAtMs: millis(row.updated_at) || createdAtMs
  };
}

/** Maps form values onto the column names used by the `students` table. */
export function toRow(values: StudentFormValues): Omit<StudentRow, 'id' | 'owner_id' | 'created_at' | 'updated_at'> {
  return {
    full_names: values.fullNames.trim(),
    gender: values.gender,
    class_name: values.className.trim(),
    father_name: values.fatherName.trim(),
    father_phone: values.fatherPhone.trim(),
    mother_name: values.motherName.trim(),
    mother_phone: values.motherPhone.trim(),
    note: values.note.trim()
  };
}
